import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Action, Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as settingActions from '../store/actions/setting.actions';

const routeActions: Record<string, Array<() => Action>> = {
  barn: [() => settingActions.loadBarnsRequest(), () => settingActions.loadVeterinarianSettings()],
  performancesetting: [
    () => settingActions.loadObservationSwitch(),
    () => settingActions.loadRVSSettings(),
    () => settingActions.loadDayOffset(),
    () => settingActions.loadUnitOfMeasureSettings(),
  ],
  farmresultsetting: [
    () => settingActions.loadBarnsRequest(),
    () => settingActions.loadFarmResultSettingsRequest(),
  ],
  finalsetupsetting: [() => settingActions.loadFinalSetupSettings()],
  discountsetting: [() => settingActions.loadDiscountSettings()],
};

@Injectable()
export class SettingsResolver {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve(route: { routeConfig?: { path?: string } }) {
    const routePath = route.routeConfig?.path ?? 'finalsetupsetting';

    for (const actionFactory of routeActions[routePath] ?? []) {
      this.store.dispatch(actionFactory());
    }

    return of(true);
  }
}
